import React from 'react';
import {
  Card, CardTitle, Badge, Typography, Button, CardBody, CardActions, SkeletonLine
} from '@one-thd/sui-atomic-components';
import {
  bool
} from 'prop-types';
import { PROJECT_ENTRY_POINT } from '../project-summary-helper';
import { EmptyMessagingPro } from '../empty-messaging/EmptyMessagingPro';
import { triggerAnalytics } from '../../helpers';

export const loadingStateCard = (
  <Card grow PaperProps={{ className: 'sui-w-full' }}>
    <CardTitle fullWidth>
      <SkeletonLine />
    </CardTitle>
    <CardBody className="sui-w-full">
      <SkeletonLine fullWidth numberOfLines={6} />
    </CardBody>
  </Card>
);

export const NoProjectsStateCard = ({ shouldShowBadge }) => {
  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }}>
      <CardTitle header={(
        <>
          {shouldShowBadge && (
            <div className="sui-mb-2">
              <Badge data-testid="beta-badge" variant="regular" color="info">Beta</Badge>
            </div>
          )}
          <Typography data-testid="card-title" height="tight" variant="h3" weight="bold">
            Projects
          </Typography>
        </>
      )}
      />
      <CardBody className="sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full">
        <EmptyMessagingPro />
      </CardBody>
      <div className="sui-grid sui-grid-cols-2 sui-gap-16 sui-mt-6 sui-mb-4">
        <div className="sui-col-span-2 sm:sui-col-span-1">
          <CardActions>
            <Button
              variant="secondary"
              fullwidth
              href="/projects"
              onClick={() => triggerAnalytics(PROJECT_ENTRY_POINT, { entryPoint: 'create new project' })}
            >
              Create New Project
            </Button>
          </CardActions>
        </div>
      </div>
    </Card>
  );
};

NoProjectsStateCard.propTypes = {
  shouldShowBadge: bool
};

NoProjectsStateCard.defaultProps = {
  shouldShowBadge: false
};
